import React, { useMemo } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useTimezone } from '../../contexts/TimezoneContext';
import zaminoEmblem from '@/assets/zamino-emblem.png';

function getGreeting(hour: number): string {
  if (hour >= 5 && hour < 12) return 'Good morning';
  if (hour >= 12 && hour < 17) return 'Good afternoon';
  if (hour >= 17 && hour < 21) return 'Good evening';
  return 'Good night';
}

const ChatGreeting: React.FC = () => {
  const { user } = useAuth();
  const { toUserTimezone } = useTimezone();

  const greeting = useMemo(() => {
    const now = toUserTimezone(new Date());
    return getGreeting(now.getHours());
  }, [toUserTimezone]);

  const firstName = user?.firstName ?? 'there';

  return (
    <div className="flex flex-col items-center mb-10" style={{ animation: 'greeting-in 400ms ease-out' }}>
      <img
        src={zaminoEmblem}
        alt="Zamino"
        className="h-20 md:h-24 w-auto mb-5 select-none"
        draggable={false}
      />
      <h1 className="text-2xl md:text-4xl font-semibold text-foreground text-center">
        {greeting}, {firstName}
      </h1>
    </div>
  );
};

export default ChatGreeting;
